import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Filter } from '@bibliocommons/base-icons';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { StickyToggleButton } from '@bibliocommons/base-drawer';

import './FacetDrawerToggle.scss';

class FacetDrawerToggle extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderCompact', 'renderFull');
  }

  renderFilterCount() {
    if (this.props.activeFilterCount > 0) {
      return (
        <FormattedNumber value={this.props.activeFilterCount}>
          {
            (number) => (<span>&nbsp;({number})</span>)
          }
        </FormattedNumber>
      );
    }
    return <noop />;
  }

  renderCompact() {
    return (
      <span>
        <Filter className="small" />
        <ScreenReaderMessage>
          <FormattedMessage id="Facets.filterResults" />
        </ScreenReaderMessage>
        {this.renderFilterCount()}
      </span>
    );
  }

  renderFull() {
    return (
      <span className="full-content">
        <Filter className="small" />
        <FormattedMessage id="Facets.filterResults" />
        {this.renderFilterCount()}
      </span>
    );
  }

  render() {
    return (
      <StickyToggleButton
        className="cp-facet-drawer-toggle"
        drawerActions={this.props.drawerActions}
        renderCompact={this.renderCompact}
        renderFull={this.renderFull} />
    );
  }
}

FacetDrawerToggle.propTypes = {
  activeFilterCount: React.PropTypes.number,
  drawerActions: React.PropTypes.objectOf(React.PropTypes.func)
};

export default FacetDrawerToggle;



// WEBPACK FOOTER //
// ./app/components/shared/Facets/FacetDrawerToggle/FacetDrawerToggle.jsx